import React from 'react';
import { Link, Route } from 'react-router-dom'
import Be from '../../icons/components/be.js'
import './description.css';
import FlechaAbajo from '../../icons/components/flechaAbajo.js'

class descriptionProject extends React.Component {

  constructor(props){
    super(props)
    this.state={
      bajo:4
    }
  }

  adicionarUno(){
    try{
      this.setState({bajo:1});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarDos(){
    try{
      this.setState({bajo:2});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarTres(){
    try{
      this.setState({bajo:3});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarFinal(){
    try{
      this.setState({bajo:4});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }

  aparece(){
    if (this.state.bajo == 1) {
      return  <p>This project started as a university project, the task was to make a competition game. Where players can challenge each other, and win or lose. We also had to take the technical side into account. Since it had to be programmed in JAVA using Processing and Android for control.</p>
    } else if (this.state.bajo == 2) {
      return  <p>With this in mind, sketches were made and the most efficient interaction possible was sought, as there was very little time for development. An idea of world invasion was developed in a race, since at that time games like Dark Souls or Watch Dogs were at their peak.</p>
    } else if (this.state.bajo == 3) {
      return  <p>The following application is based on a concept of competence. It is a game in which a user by a mobile device connects to the game (max 4 players) that works from a computer. </p>
    } else if (this.state.bajo == 4) {
      return  <p>Users are identified by their color and shape assigned to their character and from the mobile device the player controls their character. On the other screens, they can visualize the positions of their opponents. The goal is to reach the goal first, avoiding obstacles and shooting opponents. </p>
    }
  }

  render() {
    return (
      <div className='descripcionProjecto'>

        <section className="flecha">
          <Link to='/projectsMonucks' >
        <figure className="flechaAbajo">
        <FlechaAbajo size={23} color="white" />
        </figure>
        </Link>
        </section>

        <div className='tituloProjecto '>
          <h2 className='estiloFuente'>Verbindung</h2>
          <div className='estiloFuente'>
            <h3>Game</h3>
            <h3 className='fecha'>2017</h3>
          </div>
        </div>
        <div className='pasosProceso '>
          <div className='estiloFuente'><h2>Process Step</h2></div>

          <div className='estiloFuente'>
            <div className='numberStep'  onClick={this.adicionarUno.bind(this)} >  1 </div>
            <div className='numberStep' onClick={this.adicionarDos.bind(this)}>  2   </div>
            <div className='numberStep' onClick={this.adicionarTres.bind(this)}>  3   </div>
            <div className='numberStep' onClick={this.adicionarFinal.bind(this)}>  Final </div>
          </div>

          <div className='hijoTresTres'>

            {this.aparece()}
          </div>
        </div>
        <div className='hijoTresCuatro '>
          <div className='estiloFuente'><h3>Repositorio o url del proyecto:</h3></div>
          <div className='estiloFuente'>
            <a  href="https://www.behance.net/gallery/64448959/Verbindung-Game" >
            <figure className="be">
              <Be size={30} color="white" />
            </figure>
          </a>
          </div>
        </div>
      </div>
    )}
  }

  export default descriptionProject;



// WEBPACK FOOTER //
// ./src/projects/Verbingdung/description.js